<template>
  <div :class="['homepage-video', 'grey', 'darken-4']" :style="makeHomePageVideoThumb">
    <div>
      <div v-html="$config.appFullName" :class="['unselectable', 'font-weight-light', 'text-xs-center', 'large-headline', `${$config.colors.primary}--text`]" />
    </div>
    <v-btn @click="onVideoPlayBtnClick" aria-label="play-video" :title="$lang.play(video.title)" flat icon large>
      <v-icon :class="['play-homepage-video']" :color="$config.colors.primary">mdi-play-circle-outline</v-icon>
    </v-btn>
    <iframe v-if="!$config.playVideosOnFacebook" title="facebook-embedded-player" :class="['hidden-sm-and-down']" seamless width="100%" height="100%" scrolling="no" frameborder="0" allowfullscreen="false" allow="autoplay" :src="makePlayerUrl()" />
  </div>
</template>
<script>
import methods from '../mixins/methods'

export default {
  name: 'HomepageVideo',
  mixins: [
    methods
  ],
  props: {
    video: {
      type: Object,
      required: true,
      default: null
    }
  },
  computed: {
    makeHomePageVideoThumb () {
      return {
        backgroundImage: `url(${!this.$config.playVideosOnFacebook ? '/static/images/og-image.jpg' : '/static/images/' + this.video.slug + '.jpg'})`
      }
    }
  },
  methods: {
    makePlayerUrl () {
      const config = this.$config
      return `${config.facebookVideoPlayerRoot}/${config.bcArtistSlug}/videos/${this.video.id}/&show_text=false&autoplay=true&mute=true`
    },
    onVideoPlayBtnClick () {
      const video = this.video
      const id = video.id
      this.gtagEvent('play', 'video', 'single-video-page', video.title)
      this.$config.playVideosOnFacebook ? window.open(`https://www.facebook.com/watch/?v=${id}`, '_blank') : this.$router.push({
        path: this.makeSingleVideoUrl(id)
      })
    }
  }
}
</script>
<style>
.homepage-video
{
  width: 100%;
  position: fixed;
  height: 100%;
  top: -8px;
  left: 0;
  background-image: url('/static/images/og-image.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.homepage-video iframe
{
  border: 0;
  display: block;
}

.homepage-video > div
{
  position: fixed;
  backdrop-filter: blur(16px);
  height: 100vh;
  width: 100vw;
  background: rgba(0, 0, 0, .85);
}

.homepage-video .large-headline
{
  text-transform: uppercase;
  letter-spacing: .25em !important;
  position: fixed;
  top: 50%;
  display: block;
  width: 100%;
  transform: translateY(-25%);
  font-size: 3.5vw;
  background: -webkit-linear-gradient(#fff, #673ab7);
  background: linear-gradient(#fff, #673ab7);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-fill-color: transparent;
  text-shadow: 0 0 10px #fff,
               0 0 20px #fff,
               0 0 30px #fff,
               0 0 40px #673ab7,
               0 0 70px #673ab7,
               0 0 80px #673ab7,
               0 0 100px #673ab7;
}

.homepage-video .v-btn
{
  position: absolute;
  bottom: 64px;
  right: 26px;
}

.homepage-video .v-btn .v-icon
{
  font-size: 3em;
}
</style>



// WEBPACK FOOTER //
// src/components/homepage-video.vue